module.exports = __webpack_public_path__ + "static/media/ic_pdf.ce825c7d.svg";